import { PAGINATION_DEFAULT_PER_PAGE_VALUE } from '@/constants/utils/pagination.js';
import LS from '../services/LocalStorageService';
import localStorageKeySanitize from '../src/procedures/local-storage-key-sanitize';

const LOCAL_STORAGE_PAGINATION_KEY = `pagination`;

export default class {

  _buildAccessorPerPage(key) {
    return `${ this._buildRootAccessor(key) }.perPage`;
  }


  _buildRootAccessor(key) {
    return `${ localStorageKeySanitize(key) }`;
  }


  _unsetIfEmpty(pagination, ROOT_ACCESSOR) {
    if (_.isEmpty(_.get(pagination, ROOT_ACCESSOR))) {
      _.unset(pagination, ROOT_ACCESSOR);
    }
  }


  getPerPage(key) {
    return LS.get(LOCAL_STORAGE_PAGINATION_KEY, this._buildAccessorPerPage(key)) || PAGINATION_DEFAULT_PER_PAGE_VALUE;
  }


  setPerPage(key, value) {
    let pagination = LS.get(LOCAL_STORAGE_PAGINATION_KEY) || {};
    const ACCESSOR = this._buildAccessorPerPage(key);
    const ROOT_ACCESSOR = this._buildRootAccessor(key);

    if (PAGINATION_DEFAULT_PER_PAGE_VALUE === ~~value) {
      _.unset(pagination, ACCESSOR);
      this._unsetIfEmpty(pagination, ROOT_ACCESSOR);
    } else {
      _.set(pagination, ACCESSOR, value);
    }

    LS.set(LOCAL_STORAGE_PAGINATION_KEY, pagination);
  }

}
